import React from "react";
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components';

const ItemStyles = styled.div`

    background-color: var(--white);
    border-radius: 5px;
    box-shadow: 0 5px 10px -3px rgba(0,0,0,.25);
    overflow: hidden;
    transition: box-shadow .3s ease;

    &:hover {
        box-shadow: 0 10px 20px -6px rgba(0,0,0,.5);
    }
    
    .gatsby-image-wrapper {
        height: 27.5rem;
        display: block;
    }

    .product__item-details {
        padding: .5rem 1rem;
        background-color: var(--white);
        h3 {
        color: var(--black);
        font-size: 1.8rem !important;
        }
    }

    .product__item-price {
        color: var(--grey);
    }

    .product__item-action {
        display: flex;
        justify-content: space-between;
    }

    .product__item-snipcart {
        position: absolute;
        left: -5000px;
        top: auto;
        width: 1px;
        height: 1px;
        overflow: hidden;
        visibility: hidden;
    }
`;

export default function ProductItem({ product }) {
    const image = getImage(product.images[0].asset);
    return (
        <ItemStyles key={product.id} className="product__item">
            <Link to={`/${product._type}/${product.slug.current}`}>
                <GatsbyImage image={image} alt={product.name} />
                <div className="product__item-details">
                    <h3>{product.name}</h3>
                    <div className="product__item-action">
                        <div className="product__item-price">
                            <span>${product.price}</span>
                        </div>
                    </div>
                </div>
            </Link>
            {/* hidden product details 'button' for snipcart api fetch */}
            <div className="product__item-snipcart snipcart-add-item"
                aria-hidden="true"
                data-item-id={product.id}
                data-item-price={product.price}
                data-item-url={`https://imjustbeastin.netlify.app/${product._type}s`}
                data-item-description={product.description}
                data-item-image={product.images[0].asset.url}
                data-item-name={product.name}
                data-item-custom1-name={product.variants.length ? 'Size' : null}
                data-item-custom1-options={product.variants.length ? product.variants[0].sizes.join('|') : null}
            >
               hidden snipcart api
            </div>
        </ItemStyles>
    );
}